import Image from "next/image";
import Link from "next/link";
import ReputechLogo from "@/public/brand/logo.svg";

export function ReputechHeader() {
  return (
    <header className="sticky top-0 z-30 border-b border-black/10 bg-white/95 backdrop-blur">
      <div className="mx-auto flex min-h-[72px] w-full max-w-[1200px] items-center justify-between gap-4 px-4 sm:px-6">
        <Link aria-label="Reputech home" className="shrink-0" href="/">
          <Image alt="Reputech" height={36} priority src={ReputechLogo} width={174} />
        </Link>
        <span className="hidden text-sm text-black/50 sm:block">Trustpilot review removal</span>
        <a
          className="shrink-0 rounded-full border border-black/15 px-4 py-2 text-sm font-medium text-[#173f3e] transition-colors hover:bg-[#f1f7f6] max-[420px]:px-3 max-[420px]:text-xs"
          href="mailto:support@reputech.io"
        >
          Contact support
        </a>
      </div>
    </header>
  );
}
